import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";

export const QUOTATIONS_COMPUTED = gql`
  subscription quotationsComputed($documentId: Int!) {
    quotationsComputed(documentId: $documentId) {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const ACTIVE_DOCUMENTS_FOUND = gql`
  subscription activeDocumentsFound($documentId: Int!) {
    activeDocumentsFound(documentId: $documentId) {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const COMPUTE_QUOTATIONS_VALIDATED = gql`
  subscription computeQuotationsValidated($documentId: Int!) {
    computeQuotationsValidated(documentId: $documentId) {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const RETRIEVE_CONVENTIONS_VALIDATED = gql`
  subscription retrieveConventionsValidated($documentId: Int!) {
    retrieveConventionsValidated(documentId: $documentId) {
      documentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;
